import React from 'react';
import { Typography } from 'fronton-react';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { Length, Width, Height, WallHeight, AreaUser, LayerThickness } from './InputParameters';
import { DoorsQuantity, DoorsSizes } from './Doors';
import { WindowsQuantity, WindowsSizes } from './Windows';
import { TypeInstallation } from './TypeInstallation';
import { EditParamsButton } from './EditParamsButton';
import { RoomParamsContainer, ParamsListContainer, ParamsHeaderContainer } from './room-params.styles';

export const RoomParamsComponent: React.FC = () => {
  const { desktop, largeDesktop } = useBreakpoints() ?? {};
  const isLargeScreen = desktop || largeDesktop;

  return (
    <RoomParamsContainer>
      <ParamsHeaderContainer>
        <Typography variant="s" size="body_short" color={isLargeScreen ? 'text-minor' : 'text-primary'}>
          Параметры помещения
        </Typography>
      </ParamsHeaderContainer>
      <EditParamsButton />
      {isLargeScreen ? (
        <ParamsListContainer data-testid="calculation-params-list">
          <Length />
          <Width />
          <Height />
          <WallHeight />
          <AreaUser />
          <DoorsQuantity />
          <DoorsSizes />
          <WindowsQuantity />
          <WindowsSizes />
          <LayerThickness />
          <TypeInstallation />
        </ParamsListContainer>
      ) : null}
    </RoomParamsContainer>
  );
};
